import type { JobMonitoringStatus } from '../types/jobMonitoring.types';

export function mapRawStatusToJobStatus(raw: string): JobMonitoringStatus | null {
    const s = (raw ?? '').toString().toLowerCase().trim();

    switch (s) {
        case 'initializing':
            return 'initializing';
        case 'running':
            return 'running';
        case 'finished':
        case 'success':
        case 'completed':
            return 'finished';
        case 'failed':
        case 'error':
            return 'failed';
        case 'stopped':
            return 'stopped';
        default:
            return null;
    }
}